var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "boss-main-content-wrap boss-main-content-wrap-custom" },
    [
      _c("table", { staticClass: "boss-phase-table" }, [
        _c(
          "tr",
          [
            _vm._m(0),
            _vm._v(" "),
            _vm._l(_vm.phases, function (phase, i) {
              return [
                _c(
                  "td",
                  {
                    key: i,
                    staticClass: "boss-phase-table-head",
                    class: _vm.selectionStyle(i),
                    attrs: { "data-test": "phase" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "position-relative boss-phase-table-padding",
                      },
                      [
                        _c("span", {
                          staticClass: "boss-phase-table-head-arrow",
                        }),
                        _vm._v(_vm._s(phase.name) + "\n          "),
                      ]
                    ),
                  ]
                ),
              ]
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "tr",
          [
            _c("td", {
              staticClass: "is-boss-phase-table-space is-boss-plain",
            }),
            _vm._v(" "),
            _vm._l(_vm.phases, function (_, i) {
              return [
                _c("td", {
                  key: i,
                  staticClass: "is-boss-phase-table-space",
                  class: _vm.selectionStyle(i),
                }),
              ]
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "tr",
          { staticClass: "pega-table-border pega-overflow-wrap-break-word" },
          [
            _c("th", [_vm._v("日程")]),
            _vm._v(" "),
            _vm._l(_vm.transformSelection.schedules, function (schedule, i) {
              return [
                _c(
                  "td",
                  {
                    key: i,
                    class: _vm.selectionStyle(i),
                    attrs: { "data-test": "schedule" },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm._f("formatNoData")(
                            _vm._f("scheduleFilter")(schedule)
                          )
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "tr",
          { staticClass: "pega-table-border" },
          [
            _c("th", [_vm._v("評価")]),
            _vm._v(" "),
            _vm._l(_vm.transformSelection.evaluationNames, function (name, i) {
              return [
                _c(
                  "td",
                  {
                    key: i,
                    class: _vm.selectionStyle(i),
                    attrs: { "data-test": "evaluation" },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm._f("formatNoData")(name)) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "tr",
          { staticClass: "pega-table-border" },
          [
            _c("th", [_vm._v("選考ステータス")]),
            _vm._v(" "),
            _vm._l(_vm.transformSelection.statusNames, function (name, i) {
              return [
                _c(
                  "td",
                  {
                    key: i,
                    class: _vm.selectionStyle(i),
                    attrs: { "data-test": "status" },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm._f("formatNoData")(name)) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            }),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "boss-phase-table-head is-boss-plain" }, [
      _c("span", { staticClass: "boss-phase-table-head-arrow" }),
      _vm._v("選考フェーズ\n      "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }